import React, { useEffect, useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEconsultCaseDetailsContext } from '../econsultCaseDetailsContext/EconsultCaseDetailsContext';
import { FhirResourceTypes } from '@oh-vcp/components-common';

const StyledReportSection = styled(Box)(({ theme }) => ({
  borderColor: theme.palette.base.grey5,
  borderWidth: 1,
  borderStyle: 'solid',
  borderRadius: 3,
  padding: 10
}));

const LineFormattedText = styled(Typography)({
  whiteSpace: 'pre-line'
});

const EconsultClinicalReportsDetails = () => {
  const { t } = useTranslation();
  const { caseDetails } = useEconsultCaseDetailsContext();
  const [referralContent, setReferralContent] = useState<any>();

  useEffect(() => {
    if (caseDetails?.externalReferralContent) {
      setReferralContent(JSON.parse(caseDetails?.externalReferralContent));
    }
  }, [caseDetails?.externalReferralContent]);

  if (!referralContent) return null;

  const REPORT_SECTIONS = [
    { type: FhirResourceTypes.AllergyIntolerance, labelKey: 'ClinicalReports.allergyIntolerance' },
    { type: FhirResourceTypes.Condition, labelKey: 'ClinicalReports.condition' },
    { type: FhirResourceTypes.MedicationRequest, labelKey: 'ClinicalReports.medications' },
    {
      type: FhirResourceTypes.FamilyMemberHistory,
      labelKey: 'ClinicalReports.familyMemberHistory'
    },
    { type: FhirResourceTypes.Observation, labelKey: 'ClinicalReports.observations' },
    { type: FhirResourceTypes.DiagnosticReport, labelKey: 'ClinicalReports.diagnosticReports' },
    { type: FhirResourceTypes.Immunization, labelKey: 'ClinicalReports.immunizations' },
    { type: FhirResourceTypes.Procedure, labelKey: 'ClinicalReports.procedures' },
    { type: FhirResourceTypes.Encounter, labelKey: 'ClinicalReports.encounters' }
  ];

  return (
    <>
      {REPORT_SECTIONS.filter(({ type }) => referralContent[type])
        .sort((a, b) => t(a.labelKey).localeCompare(t(b.labelKey)))
        .map(({ type, labelKey }, index) => (
          <React.Fragment key={type}>
            <Typography variant="h5" color="base.grey4" mb={1} mt={index === 0 ? 0 : 3}>
              {t(labelKey)}
            </Typography>
            <StyledReportSection>
              <LineFormattedText variant="body2" color="base.grey3">
                {referralContent[type]}
              </LineFormattedText>
            </StyledReportSection>
          </React.Fragment>
        ))}
    </>
  );
};

export default EconsultClinicalReportsDetails;
